import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'

import selectors from '../../redux/selectors'
import actions from '../../redux/actions'
import { EMAIL_CAMPAIGNS } from '../../config/table-columns'
import { ITEMS_PER_PAGE, PATHS } from '../../config/constants'
import { setDocumentTitle } from '../../utils/functions'
import Pagination from '../../components/Pagination'
import PageTitle from '../../components/PageTitle'
import { withLang } from '../../utils/withLang'

const mapStateToProps = state => ({
  emailCampaigns: selectors.emailCampaigns.getAll(state),
  count: selectors.emailCampaigns.getCount(state),
  isFetching: selectors.emailCampaigns.getIsFetching(state),
})

class CampaignsHome extends Component {
  state = {
    page: null,
    ordering: '',
  }

  componentDidMount () {
    setDocumentTitle('Email Campaigns')
    this.resolveParams()
  }

  componentDidUpdate () {
    this.resolveParams()
  }

  resolveParams = () => {
    const params = new URLSearchParams(this.props.location.search)
    const pageParam = params.get('page') ? +params.get('page') : 1
    const ordering = params.get('ordering') || ''

    if (this.state.page !== pageParam || this.state.ordering !== ordering) {
      this.setState({ page: pageParam, ordering }, this.fetch)
    }
  }

  fetch = () => {
    const { dispatch } = this.props
    const { page, ordering } = this.state
    dispatch(actions.emailCampaigns.fetchEmailCampaigns({ page, ordering , page_size: ITEMS_PER_PAGE }))
  }

  handleSortChange = (column, direction) => {
    const ordering = direction === 'asc' ? column : `-${column}`
    const params = new URLSearchParams(this.props.location.search)
    params.set('ordering', ordering)
    params.set('page', '1')
    this.props.history.push({ pathname: PATHS.EMAIL_CAMPAIGNS, search: params.toString() })
  }

  handleNewClick = () => {
    this.props.dispatch(actions.emailCampaigns.openModalForm())
  }

  render () {
    const { emailCampaigns, count, isFetching, lang } = this.props

    return (
      <div className="email-campaigns">
        <PageTitle
          title={lang.campaign_send}
          icon="bullhorn"
          iconClassName={"flip-horizontal"}
          onCreateClick={this.handleNewClick}
        />

        <ReactTable
          showPagination={false}
          data={emailCampaigns}
          columns={EMAIL_CAMPAIGNS.map(col => ({
            ...col,
            sortable: true,
            Header: (
              <div
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  this.handleSortChange(
                    col.accessor,
                    this.state.ordering === col.accessor ? 'desc' : 'asc'
                  )
                }
              >
                {col.Header}
              </div>
            ),
          }))}
          defaultPageSize={ITEMS_PER_PAGE}
          className="-striped -highlight"
          loading={isFetching}
          noDataText={
            isFetching ? `${lang.loading}...` : lang.no_email_campaigns || 'אין קמפיינים להצגה'
          }
        />

        <Pagination
          totalItems={count}
          path={PATHS.EMAIL_CAMPAIGNS}
          isFetching={isFetching}
          page={this.state.page}
          perPage={ITEMS_PER_PAGE}
        />

      </div>
    )
  }
}

export default withRouter(
  withLang(connect(mapStateToProps)(CampaignsHome))
)
